<button type="button" class="grid-manage-column-menu-trigger">
    {{icon "gear" "Toggle menu" }}
</button>

<div id="region-manage-columns-menu"></div>